export const experiences = [
  {
    id: 1,
    title: "Manager",
    company: "Rakuten",
    companyUrl: "https://www.crunchbase.com/organization/rakuten",
    period: "2026 – Present",
    location: "",
    description: `<p>Software Engineering Manager in the Travel Development Department, leading software engineers in building and maintaining travel products and services.</p>`
  },
  {
    id: 2,
    title: "Head of Technology",
    company: "commsult",
    companyUrl: "https://www.crunchbase.com/organization/commsult-ff71",
    period: "2024 – 2026",
    location: "",
    description: `<p>Leading Technology Department with 20+ engineers across product development, ERP integration, and custom software solutions for clients in Europe and Southeast Asia.</p>`
  },
  {
    id: 3,
    title: "Engineering Manager – Consumer Lending / BNPL",
    company: "Traveloka",
    companyUrl: "https://www.crunchbase.com/organization/traveloka",
    period: "2022 – 2024",
    location: "",
    description: `<p>Led engineering teams for acquisition and recovery flows in lending product, working on compliance systems and backend architecture.</p>`
  },
  {
    id: 4,
    title: "Engineering Manager – Payments & Fintech",
    company: "Bukalapak",
    companyUrl: "https://www.crunchbase.com/organization/bukalapak",
    period: "2020 – 2022",
    location: "",
    description: `<p>Managed fintech engineering squads for wallet integrations and payment reconciliation systems.</p>`
  },
  {
    id: 5,
    title: "Software Engineer – O2O / Mitra Bukalapak",
    company: "Bukalapak",
    companyUrl: "https://www.crunchbase.com/organization/bukalapak",
    period: "2018 – 2020",
    location: "",
    description: `<p>Built O2O wallet features and KYC systems for small business partners.</p>`
  },
  {
    id: 6,
    title: "Software Engineer",
    company: "Nomura Research Institute",
    companyUrl: "https://www.crunchbase.com/organization/nomura-research-institute",
    period: "2017 – 2018",
    location: "",
    description: `<p>Developed enterprise systems and analytical tools working on backend services and microservice architecture.</p>`
  },
  {
    id: 7,
    title: "Development Staff & Teaching Assistant",
    company: "Bina Nusantara University",
    companyUrl: "https://www.crunchbase.com/organization/binus-university",
    period: "2012 – 2015",
    location: "",
    description: `<p>Managed software and network infrastructure at Software Laboratory Center.</p>`
  }
]; 